import React from 'react';
import { Coins } from 'lucide-react';

export default function ConsolationBanner() {
  return (
    <section
      data-testid="consolation-banner"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10"
    >
      <div
        className="relative rounded-2xl p-[1px]"
        style={{
          backgroundImage:
            'linear-gradient(120deg, rgba(212,175,55,0.85) 0%, rgba(255,215,0,0.35) 45%, rgba(212,175,55,0.85) 100%)',
        }}
      >
        <div className="rounded-2xl bg-[#0a0a0a] px-6 py-8 sm:px-10 sm:py-10 flex flex-col sm:flex-row items-center sm:items-center gap-5 sm:gap-8 text-center sm:text-left relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none grain-overlay opacity-25" />

          <div
            data-testid="consolation-icon"
            className="relative shrink-0 h-16 w-16 rounded-full flex items-center justify-center"
            style={{
              backgroundImage:
                'radial-gradient(circle at 30% 30%, #FFD700 0%, #D4AF37 45%, #8a6f1e 100%)',
              boxShadow: '0 0 22px rgba(212,175,55,0.35), inset 0 1px 0 rgba(255,255,255,0.25)',
            }}
          >
            <Coins size={30} className="text-black/85" />
          </div>

          <div className="relative flex-1">
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.32em] text-[#D4AF37] font-semibold mb-2">
              Consolation Reward
            </p>
            <h2
              data-testid="consolation-heading"
              className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-black leading-tight"
            >
              <span className="text-gold-gradient">Every Ticket Is a Winner</span>
            </h2>
            <p className="mt-3 text-sm sm:text-base text-[#C0C0C0] leading-relaxed max-w-3xl">
              Even if you don't reel in the Golden Fish, you'll still be rewarded with{' '}
              <span
                data-testid="consolation-amount"
                className="font-serif-display font-black shimmer-gold text-lg sm:text-xl align-baseline"
              >
                R0.25
              </span>{' '}
              credited to your lottery wallet on every ticket.{' '}
              <span className="text-white">Play more, win more — guaranteed.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
